// ── 미팅지도 설정 모달 — 피드백 옵션·미팅인계 담당자·배너 문구 3탭 ─────────────
// 동적관리 > 영업운영에서 이관 (2026-09-01). 미팅지도 관리 헤더의 ⚙️ 버튼으로 연다.
import React, { useEffect, useState } from 'react';
import Modal from '../../../components/Modal';
import { stdTabGroup, stdTabBtn } from '../adminlayout/designStandard';
import { useMeetingMapSettings } from './useMeetingMapSettings';
import { SettingsFeedbackPanel } from './SettingsFeedbackPanel';
import { SettingsInheritPanel } from './SettingsInheritPanel';
import { SettingsBannerPanel } from './SettingsBannerPanel';
import { SettingsMarkerPanel } from './SettingsMarkerPanel';

const TABS = [
  { key: 'feedback', label: '피드백 옵션' },
  { key: 'inherit',  label: '미팅인계 담당자' },
  { key: 'banner',   label: '배너 문구' },
  // 2026-10-24 마커 표시 설정(테넌트 전체) — 이 탭만 계약 설정처럼 넓게(왼쪽 설정 + 오른쪽 미리보기)
  { key: 'marker',   label: '마커 표시' },
];

export function MeetingMapSettingsModal({ open, onClose }) {
  const settings = useMeetingMapSettings();
  const [tab, setTab] = useState('feedback');

  // 열 때마다 3종 설정을 새로 읽는다 (다른 관리자가 바꾼 값 반영)
  useEffect(() => {
    if (!open) return;
    settings.fetchFeedbackOptions();
    settings.fetchInheritPersons();
    settings.fetchBanner();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Modal
      open={open}
      title="미팅지도 설정"
      icon="⚙️"
      onClose={onClose}
      width={tab === 'marker' ? 'min(1040px, calc(100vw - 48px))' : 'min(680px, calc(100vw - 48px))'}
      mobileSheet
      mobileSheetDragClose
    >
      <div className="grid gap-3">
        <div style={stdTabGroup} className="w-fit">
          {TABS.map((t) => (
            <button key={t.key} type="button" style={stdTabBtn(tab === t.key)} onClick={() => setTab(t.key)}>
              {t.label}
            </button>
          ))}
        </div>
        {tab === 'feedback' && <SettingsFeedbackPanel {...settings} />}
        {tab === 'inherit'  && <SettingsInheritPanel {...settings} />}
        {tab === 'banner'   && <SettingsBannerPanel {...settings} />}
        {tab === 'marker'   && <SettingsMarkerPanel />}
      </div>
    </Modal>
  );
}
